import React, { useState } from 'react';
import "../pages/PromoCard.css";
import { useCommonVars } from './useCommonVars';

function ReadButton({ onClick }) {
  const [pressed, setPressed] = useState(false);
  return (
    <div
      className={`read-button${pressed ? " pressed" : ""}`}
      tabIndex={0}
      role="button"
      onMouseDown={() => setPressed(true)}
      onMouseUp={() => setPressed(false)}
      onMouseLeave={() => setPressed(false)}
      onTouchStart={() => setPressed(true)}
      onTouchEnd={() => setPressed(false)}
      onClick={onClick}
      style={{ userSelect: "none" }}
    >
      <span>Читать</span>
    </div>
  );
}

const PromoCard = ({ user, btc, usdt, ton, eth }) => {
  const { channelUrl, chatUrl, supportUrl, trainingUrl } = useCommonVars(user);
  const faqData = [
    {
      question: "Как пополнить баланс?",
      answer: "Для пополнения баланса перейдите в раздел «Главная», далее нажмите на кнопку «Пополнить», укажите сумму (от 100₽) и выберите удобный способ оплаты."
    },
    {
      question: "Можно ли вывести средства?",
      answer: "Да, средства можно вывести в любое время через раздел «Вывод»."
    },
    {
      question: "Пополнил счёт, но средства не поступили. Что делать?",
      answer: "В случае задержки поступления средств напишите в поддержку, прикрепите подтверждение платежа (чек или скриншот) и опишите проблему."
    },
    {
      question: "Что такое реинвестирование?",
      answer: "Реинвестирование — это повторное вложение полученного дохода для увеличения прибыли."
    }
  ];

  const FaqItem = ({ question, answer, isOpen, toggle }) => (
    <div className={`faq-card${isOpen ? ' open' : ''}`} onClick={toggle}>
      <span className="faq-question">{question}</span>
      <div className="faq-answer-wrapper">
        <div className="faq-answer">{answer}</div>
      </div>
    </div>
  );

  const [faqOpenStates, setFaqOpenStates] = useState(faqData.map(() => false));



  return (
    <div className="main-container">
      <div className="promo-card">
	  <div className="promo-box">
		<span role="img" aria-label="book" style={{ marginRight: 8 }}>🎓</span>
		Обучение
	  </div>
	  <div className="circle circle1" />
	  <div className="circle circle2" />
	  <div className="circle circle3" />
	  <div className="circle circle4" />
	  <div className="circle circle5" />
	  <div className="promo-date">21 октября 2025г.</div>
	  <ReadButton onClick={() => window.open(trainingUrl, "_blank")} />
	</div>
      <div className="about-card">
        <div className="about-circle circle-a1" />
        <div className="about-circle circle-a2" />
        <div className="about-circle circle-a3" />
        <div className="about-circle circle-a4" />
        <div className="about-title">О нас</div>
        <div className="about-text">
          Vault Capital — первая криптовалютная p2p-платформа, ориентированная на максимальную эффективность капитала.
        </div>
      </div>
      <div className="why-us-card">
        <div className="why-circle circle-w1" />
        <div className="why-circle circle-w2" />
        <div className="why-circle circle-w3" />
        <div className="why-circle circle-w4" />
        <div className="why-title">Почему выбирают нас?</div>
        <div className="why-points">
          <div className="why-bullet">
            <span className="bullet-line" />
            Высокая доходность
          </div>
          <div className="why-bullet">
            <span className="bullet-line" />
            Быстрые выплаты
          </div>
          <div className="why-bullet">
            <span className="bullet-line" />
            100% надежность
          </div>
        </div>
      </div>
      <div className="faq-container">
        <div className="faq-title">FAQ</div>
        {faqData.map((item, index) => (
          <FaqItem
            key={index}
            question={item.question}
            answer={item.answer}
            isOpen={faqOpenStates[index]}
            toggle={() => {
              const newStates = [...faqOpenStates];
              newStates[index] = !newStates[index];
              setFaqOpenStates(newStates);
            }}
          />
        ))}
        <div className="info-section">
          <div className="info-title">Информация</div>
          <div className="info-support">
              <div className="support-links">
                <a href={supportUrl} target="_blank" rel="noopener noreferrer" className="support-link" title="Поддержка">
                  <span className="icon">
                    <svg width="16" height="16" viewBox="0 0 24 24" fill="none">
                      <path d="M4 15V11C4 6.582 7.582 3 12 3C16.418 3 20 6.582 20 11V15" stroke="currentColor" strokeWidth="2"/>
                      <rect x="2" y="15" width="5" height="6" rx="2" stroke="currentColor" strokeWidth="2"/>
                      <rect x="17" y="15" width="5" height="6" rx="2" stroke="currentColor" strokeWidth="2"/>
                      <path d="M12 21V19" stroke="currentColor" strokeWidth="2"/>
                    </svg>
                  </span>
                  Поддержка
                </a>
                <span className="dot-sep">·</span>
                <a href={channelUrl} target="_blank" rel="noopener noreferrer" className="support-link" title="Канал">
                  <span className="icon">
                    <svg width="16" height="16" viewBox="0 0 24 24" fill="none">
                      <path d="M21 3L3 10.53L8.38 12.06L18.25 6.03C18.66 5.78 19.08 6.22 18.82 6.62L12.38 16.5V16.5L12.37 16.5L12.38 16.5V16.5L14.12 20.16C14.34 20.62 14.97 20.65 15.24 20.21L21 3Z" fill="currentColor"/>
                    </svg>
                  </span>
                  Канал
                </a>
                <span className="dot-sep">·</span>
                <a href={chatUrl} target="_blank" rel="noopener noreferrer" className="support-link" title="Чат">
                  <span className="icon">
                    <svg width="16" height="16" viewBox="0 0 24 24" fill="none">
                      <path d="M21 11.5C21 16.1944 16.9706 20 12 20C10.5709 20 9.22432 19.7453 8.02781 19.2929L3 20.5L4.20711 15.6725C3.44217 14.5208 3 13.0716 3 11.5C3 6.80558 7.02944 3 12 3C16.9706 3 21 6.80558 21 11.5Z" stroke="currentColor" strokeWidth="2" strokeLinejoin="round"/>
                    </svg>
                  </span>
                  Чат
                </a>
              </div>
            </div>
          <div className="info-subtitle">Партнерская программа</div>
          <div className="info-icons-box">
            <img src={btc} alt="btc" className="coin-icon" />
            <img src={usdt} alt="usdt" className="coin-icon" />
            <img src={ton} alt="ton" className="coin-icon" />
            <img src={eth} alt="eth" className="coin-icon" />
          </div>
          <div className="copyright">© 2025 | Все права защищены.</div>
        </div>
      </div>
    </div>
  );
};

export default PromoCard;



